<template>
    <div>
        <div class="modal-overlay active" @click="closeDialog()"></div>
            <div class="modal">
                <div class="modal__header">
                    <h2 id="renameListModalTitle" class="headline-s">Rename List</h2>
                    <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
                </div>
                <div class="modal__body flex-column" id="renameListModalBody">
                    <div class="input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText type="text" id="renameInput" v-model="renameListInput" placeholder=" " required />
                            <label for="renameInput">
                                <p class="paragraph-default">New List Name *</p>
                            </label>
                        </div>
                    </div>
                    <div class="modal__footer flex-row justify-end">
                    
                    <RothcoCta id="submitButton" :class="formValid ? `primary` : `disabled`" @click="submit">Submit Change</RothcoCta>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { ref, computed, inject} from "vue";
    import { router } from "@inertiajs/vue3";
    import { useLists } from "@/helpers/composables/useList";
    import RothcoCta from "@/components/RothcoCta.vue";
    import CloseIcon from "@icons/closeIcon.svg";
    let route = inject('route');
    let { renameList } = useLists({ router, route });
    let renameListInput = ref("");
    let dialogRef = inject('dialogRef');

    let listId = computed(()=>{
        return dialogRef?.value?.data?.list_id;
    })

    let beforeClose = computed(()=>{
        let defaultFunction = () => {};
        return dialogRef?.value?.data?.beforeClose ?? defaultFunction;
    })
    const formValid = computed(() => {
        return renameListInput.value != null && renameListInput.value != "";
    });
    const closeDialog = function () {
        dialogRef?.value?.close();
    };
    const submit = function () {
        let newList = {
            list_name: renameListInput.value
        };
        renameList(listId.value, newList, {
            afterFetch: () => {
                beforeClose.value(listId.value);
                closeDialog();
            }
        });
    };
</script>
